import { render, staticRenderFns } from "./CotProductsTab.vue?vue&type=template&id=ce02bb0a&scoped=true"
import script from "./CotProductsTab.vue?vue&type=script&lang=js"
export * from "./CotProductsTab.vue?vue&type=script&lang=js"
import style0 from "./CotProductsTab.vue?vue&type=style&index=0&id=ce02bb0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce02bb0a",
  null
  
)

export default component.exports